export const stringToId = str => encodeURIComponent(str.toLocaleLowerCase().replace('::', ' ').split(' ').join('-'));